export default __webpack_public_path__ + "static/banner-family-christmas-gift-guide-75c28c4a4824f44633923b9068d6d492.jpg";